export const MANAGEMENT_ITEMS = [
  {
    title: 'Branch Management',
    icon: 'building-bank',
    description:
      'Add, edit, or organize branches to keep your operational structure clear and efficient.',
    route: 'organization.branches',
  },
  {
    title: 'Service Management',
    icon: 'service',
    description:
      'Maintain a centralized list of services and ensure consistency across all branches.',
    route: 'organization.services',
  },
  {
    title: 'Staff Management',
    icon: 'person',
    description:
      'Manage staff profiles, assignments, and availability with ease and transparency.',
    route: 'organization.staffs',
  },
  {
    title: 'Condition Management',
    icon: 'stethoscope',
    description:
      'Manage condition profiles, assignments, and availability with ease and transparency.',
    route: 'organization.conditions',
    moduleRestricted: true,
  },
  {
    title: 'Promotion Management',
    icon: 'ticket',
    description:
      'Manage promotions and e-vouchers with ease and transparency.',
    route: 'organization.promotions',
    moduleRestricted: true,
  },
  {
    title: 'Staff Calendar',
    icon: 'calendar',
    description:
      'Manage staff schedules and availability with ease and transparency.',
    route: 'organization.staff-calendar',
  },
]
